export const VDP_API_ENDPOINT = '/api/retail-product/variable-delivery-price/v1/sku-delivery-prices';
export const WIREMOCK_LOCAL_HOST = 'http://127.0.0.1:3000';
export const WIREMOCK_HOST = 'https://mock.qa.theverygroup.com';
